/**
 * The Vericure support contact, in one place.
 *
 * Policy (Joel, 2026-09-01): these two values are the support contact everywhere —
 * documentation, web.ui and Vericure desktop.
 *
 * NO AVAILABILITY CLAIM. Hours, time zone and region are deliberately absent and
 * MUST NOT be added or inferred. The area code is Greenville SC; that is not a
 * statement that support is US-only or US-hours, and nothing in any codebase says
 * what the hours are. If a caller needs that, it has to come from Joel.
 *
 * Defined once because the previous state is what drift looks like: the QR scanner
 * carries the phone in seven hand-written copies across two branches with no email,
 * and web.ui had neither. Two literals in two files would become four in six.
 */
export const SUPPORT_EMAIL = 'vericuresupport@vortexcompanies.com';

/** Display form. */
export const SUPPORT_PHONE = '+1 864-901-5522';

/** `tel:` href form — digits only, as the QR scanner's master branch uses. */
export const SUPPORT_PHONE_TEL = '+18649015522';
